import Loader from "./component";
import { asVariation } from "../../../helper/variations";

Loader.Primary = asVariation(Loader, "primary", { typeStyle: "primary" });

Loader.Secondary = asVariation(Loader, "secondary", { typeStyle: "secondary" });

export { Loader };
